import React from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../../store';
import type { SurveyTO } from '../../../../lib';

const DiscrepencyItem = ({
  index,
  data,
}: {
  index: number;
  data: SurveyTO;
}) => {
  return (
    <div className="d-flex flex-column gap-3">
      <span className="font-weight-600 font-16">Reviewer {index}</span>
      <span className="roboto font-weight-400 font-14 color-grey d-flex flex-column gap-1">
        {data.questions.map((question) => (
          <div
            key={`survey-question-${data.userQuestionnaireId}-${question.id}`}
            className="d-flex gap-2 align-items-center flex-wrap"
          >
            <span className="w-75">{question.question}</span>
            <span className="text-center labelSimple">{question.answers}</span>
          </div>
        ))}
      </span>
    </div>
  );
};

const Discrepency = () => {
  const { surveys } = useSelector((state: RootState) => state.dataAnnotation);

  return (
    <div className="w-100 d-flex flex-column gap-4 p-3">
      {surveys.map((survey, index) => (
        <DiscrepencyItem
          key={`survey-${index}`}
          data={survey}
          index={index + 1}
        />
      ))}
    </div>
  );
};

export default Discrepency;
